type FetchInGameCompensationRewards = () => Promise<unknown>;

let fetchInGameCompensationRewards: FetchInGameCompensationRewards | null =
	null;

export function registerInGameCompensationRewardsFetcher(
	fn: FetchInGameCompensationRewards,
): void {
	fetchInGameCompensationRewards = fn;
}

/** Loads claimable in-game rewards into the reward store (CompensationBox). */
export function syncInGameCompensationRewards(): void {
	if (!fetchInGameCompensationRewards) return;
	void fetchInGameCompensationRewards().catch((error: unknown) => {
		console.error("[syncInGameCompensationRewards]", error);
	});
}
